import { type MantineRadius } from '@mantine/core';

const radiusList: Exclude<MantineRadius, number>[] = [
  'xs',
  'sm',
  'md',
  'lg',
  'xl',
];

export const getClampRadius = (
  radius: MantineRadius,
  min: MantineRadius,
  max: MantineRadius,
): MantineRadius => {
  if (
    typeof radius === 'number' &&
    typeof min === 'number' &&
    typeof max === 'number'
  ) {
    return Math.min(Math.max(radius, min), max);
  }

  if (typeof radius === 'number') {
    const minIndex = typeof min === 'number' ? min : radiusList.indexOf(min);
    const maxIndex = typeof max === 'number' ? max : radiusList.indexOf(max);

    if (minIndex === -1 || maxIndex === -1) {
      throw new Error('Invalid min or max value');
    }

    return Math.min(Math.max(radius, minIndex), maxIndex);
  }

  if (typeof min === 'number' || typeof max === 'number') {
    const radiusIndex = radiusList.indexOf(radius);
    if (radiusIndex === -1) {
      throw new Error('Invalid radius value');
    }

    const minIndex = typeof min === 'number' ? min : radiusList.indexOf(min);
    const maxIndex = typeof max === 'number' ? max : radiusList.indexOf(max);

    if (minIndex === -1 || maxIndex === -1) {
      throw new Error('Invalid min or max value');
    }

    return Math.min(Math.max(radiusIndex, minIndex), maxIndex) === radiusIndex
      ? radius
      : Math.min(Math.max(radiusIndex, minIndex), maxIndex) === minIndex
        ? min
        : max;
  }

  const radiusIndex = radiusList.indexOf(radius);
  const minIndex = radiusList.indexOf(min);
  const maxIndex = radiusList.indexOf(max);

  if (radiusIndex === -1 || minIndex === -1 || maxIndex === -1) {
    throw new Error('Invalid radius, min, or max value');
  }

  if (radiusIndex < minIndex) {
    return min;
  } else if (radiusIndex > maxIndex) {
    return max;
  } else {
    return radius;
  }
};